export default Vue => {
    console.warn('Common/Meta/IView plugin')
    Vue.prototype._validateForm = function (name, cb) {
        this.$refs[name].validate(valid => {
            if (!valid) {
                this.$Notice.error({
                    title: '表单验证不通过!'
                })
            } else if (typeof cb === 'function') {
                cb(valid)
            } else if (cb) {
                this.$Message.success('表单验证通过!')
            }
        })
    }
    Vue.prototype._validateField = function (name, field, cb) {
        var form = this.$refs[name]
        if (form) {
            this.$refs[name].validateField(field, invalid => {
                if (typeof cb === 'function') {
                    cb(invalid)
                } else if (cb) {
                    this.$Message.success(field + '验证通过!')
                }
            })
        }
    }
    Vue.prototype._resetForm = function (name) {
        this.$refs[name].resetFields()
    }
    Vue.prototype._scroll = function (evt) {
        var target = evt.target
        this._emit('scroll-top', {
            scrollTop: target.scrollTop,
            target: target
        })
    }
    Vue.prototype._rScroll = function (evt) {
        setTimeout(() => {
            this._emit('scroll-top', {
                scrollTop: 0,
                target: false
            })
        }, 200)
    }
    Vue.prototype._confirm = function (title, content, onOk) {
        this.$Modal.confirm({
            title,
            content,
            onOk
        })
    }
    Vue.prototype._info = function (title, content) {
        this.$Modal.info({
            title,
            content
        })
    }
    Vue.prototype._noticeSuccess = function (title, desc) {
        this.$Notice.success({
            title,
            desc
        })
    }
    Vue.prototype._noticeWarning = function (title, desc) {
        this.$Notice.warning({
            title,
            desc
        })
    }
    Vue.prototype._messageSuccess = function (msg) {
        this.$Message.success(msg)
    }
    Vue.prototype._requiredRule = function (key) {
        var required = {
            required: true,
            trigger: 'change',
            message: '必填'
        }
        var rules
        key = key.split(',')
        rules = {}
        key.forEach(item => {
            rules[item] = required
        })
        return rules
    }
}


// WEBPACK FOOTER //
// ./src/Common/meta/iview.js